import $ from 'jquery';

var ROUTERCONFIG =
 {
  configurations:[],
  request:{},
  selectedConfiguration:[],
  show_warning:false,
  warning_status:"",
  root_path:"",
  getString :null,
  help_info: [{type:"Band",info:"If you have a dual band router,you have the option to choose between the 2.4 GHz band and the 5 GHz band. Has a shorter range than 2.4 GHz. Not all wireless adapters support  5 GHz. Is much faster then 2.4 GHz. Less congestion problems in heavily populated areas."},
  {type:"Name",info:'Stands for "Service Set Identifier." An SSID is a unique ID that consists of 32 characters and is used for naming wireless networks. When multiple wireless networks overlap in a certain location, SSIDs make sure that data gets sent to the correct destination.'},
  {type:"Channel",info:"Every Wi-Fi network transmits and receives data on a certain frequency, or channel. As Wi-Fi data is digitla, many different devices can communicate successfully on the same channel. Channels might get congested in densely populated areas due to the default channels used which are typically either channel 6 or channel 11 on the 2.4 GHz band."},
  {type:"Protocol",info:"In 1997, the Institute of Electrical and Electronics Engineers(IEEE) created the first WLAN standard. They called it 802.11 after the name of the group formed to oversee its development, an entire family has sprung up from this initial standard. The best way to look at these standards is to consider 802.11 as the foundation, and all other iterations as building blocks upon that foundation that focus on improving both small and large aspects of the technology. Some building blocks are minor touch-ups while others are quite large. The main difference lies in the last part which describes the speed/standard used: a/b/g/n. (802.11g/80211n/etc)"},
  {type:"Encryption",info:"Encryption is the WiFi security standards that are made available by the router. This allows for a secure connection between device and the router. There are different encryption types available but at the moment WPA2 (AES) is the preferred setting."},
  {type:"Password",info:"A password is needed to get connected with the router. It is part of the encryption type and can be changed if preferred."}],
  config_type: {
   band:0,
   name:1,
   channel:2,
   protocol:3,
   encryption:4,
   password:5
  },
  band_type:{
   "2.4 Ghz":24,
   "5 Ghz":50
  },
  init: function($scope) {
   $scope.selectedConfiguration = [];
   ROUTERCONFIG.show_warning = false;
   ROUTERCONFIG.warning_status = "";
   $scope.unknown_type = ROUTERCONFIG.getString("unknown_router_type");
  },
  loadData: function($scope,info) {
   var r={};
   if(info.status == "unknown type") r = {rd:{}};
   else if(info.ecode==3||info.ecode==4) {
    r = {rd:info,show_warning_status:true,staus:info.status};
    ROUTERCONFIG.show_warning = true;
    ROUTERCONFIG.warning_status = info.status;
   }
   else r = {rd:info};
   $scope.resData = r.rd;
   if($scope.resData&&$scope.resData.channels) {
    var channels = $scope.resData.channels;
    ROUTERCONFIG.configurations = {};
    if(channels.band24) {
     ROUTERCONFIG.configurations.band24 = {name:channels.band24.ssid, band:"2.4 Ghz", channel:channels.band24.current, protocol:channels.band24.channel, encryption:$scope.resData.info.curr_encryp, encryptions:$scope.resData.info.supported_encryp.split(','), channels:channels.band24.supported.split(','),bssid:channels.band24.bssid};
    }
    if(channels.band50) {
     ROUTERCONFIG.configurations.band50 = {name:channels.band50.ssid, band:"5 Ghz", channel:channels.band50.current, protocol:channels.band50.channel, encryption:$scope.resData.info.curr_encryp, encryptions:$scope.resData.info.supported_encryp.split(','), channels:channels.band50.supported.split(','),bssid:channels.band50.bssid};
    }
    ROUTERCONFIG.selectedConfiguration.push(ROUTERCONFIG.configurations[$scope.resData.current_band]);
   }
   else $scope.nodata = true;
  },
  updateData:function(data) {
   var $scope = angular.element($('#routerConfigScreen')).scope();
   if(data.error) {
    $scope.show_warning = true;
    $scope.warning_status = data.error;
    if($scope) $scope.$apply();
    return;
   }
   var req = ROUTERCONFIG.request;
   if(req.band=="24") {
    ROUTERCONFIG.configurations.band24[req.config_type] = data.new;
   }
   else ROUTERCONFIG.configurations.band50[req.config_type] = data.new;
   if($scope) $scope.$apply();
  },
  controller : function router_config_ctrl($scope, $rootScope, $timeout,setRouterConfigValue) {
   $scope.selectedConfiguration = ROUTERCONFIG.selectedConfiguration;
   $scope.config = $scope.selectedConfiguration[0];
   if(!$scope.config) {
    $scope.nodata = true;
    return;
   }
   $scope.modify_icon = ROUTERCONFIG.root_path+ "router-config/htdocs/images/modify.svg";
   $scope.help_icon = ROUTERCONFIG.root_path+ "router-config/htdocs/images/help_outline.svg";
   $scope.show_warning = ROUTERCONFIG.show_warning;
   $scope.warning_status = ROUTERCONFIG.warning_status;
   $scope.bandTypes = ["5 Ghz","2.4 Ghz"];
   $scope.protocolTypes = ["B","G","N","AC","N + G"];
   $scope.encryptionTypes = $scope.config.encryptions;/*["WPA-PSK (TKIP)","WPA-PSK (AES)","WPA2-PSK (TKIP)","AWPA2-PSK (AES)"]*/
   $scope.selectedBandType = $scope.bandTypes[0];
   $scope.selectedProtocolType = $scope.protocolTypes[0];
   $scope.proposedEncryptionType = $scope.encryptionTypes[0];
   $scope.proposedChannelType = $scope.config.channels[0];/*TODO - replace with real suggested channel type*/
   $scope.proposedEncryptionType = $scope.encryptionTypes[0];
   $scope.bAdvanced_channel_screen = false;
   $scope.updateSSID = function(new_ssid) {
    if(!new_ssid) {
       $scope.invalid_ssid = true;
       return;
    }
    $scope.setRouterConfig($scope.config.band,"name", $scope.config.name,new_ssid,$scope.config.bssid);
    $scope.bSSIDPage = false;
    $scope.hideMainPage = false;
    $timeout(function(){$scope.$apply()},0);
   };
   $scope.onSSIDEdit = function() {
    $scope.invalid_ssid = document.getElementById("ssid_edit").value.length < 1;
   };
   $scope.onBandDropdownClick = function(band) {
    $scope.selectedBandType = band;
   };
   $scope.updateChannel = function(/*channel*/) {
    $scope.bChannelPage = false;
    $scope.hideMainPage = false;
     $scope.setRouterConfig($scope.config.band,"channel", $scope.config.channel,$scope.proposedChannelType,$scope.config.bssid);
   };
   $scope.updateProtocol = function(/*channel*/) {
    $scope.bProtocolPage = false;
    $scope.hideMainPage = false;
   };
   $scope.setEncryption = function() {
    $scope.bEncryptionPage = false;
    $scope.hideMainPage = false;
    $scope.setRouterConfig($scope.config.band,"encryption", $scope.config.encryption,$scope.proposedEncryptionType,$scope.config.bssid);
   };
   $scope.updateWifiPwd = function(/*channel*/) {
    $scope.bPasswordPage = false;
    $scope.hideMainPage = false;
   };
   $scope.onProtocolDropdownClick = function(protocol) {
    $scope.selectedProtocolType = protocol;
    $timeout(function(){$scope.$apply()},0);
   };
   $scope.changeBand = function() {
    $scope.hideMainPage = false;
    $scope.bBandPage = false;
    $scope.config = $scope.selectedConfiguration[0];
    $scope.selectedConfiguration = [];
    switch($scope.selectedBandType)
    {
     case '5 Ghz':
      $scope.selectedConfiguration.push(ROUTERCONFIG.configurations.band50);
      break;
     case '2.4 Ghz':
      $scope.selectedConfiguration.push(ROUTERCONFIG.configurations.band24);
      break;
     default :
      $scope.selectedConfiguration.push($scope.config);
    }
    $scope.config = $scope.selectedConfiguration[0];
    $timeout(function() {$scope.$apply()},0);
   };
   $scope.switchChannelScreen = function(b) {
     $scope.bAdvanced_channel_screen = !b;
   };
   $scope.onChannelDropdownClick = function(ch) {
     $scope.proposedChannelType = ch;
   };
   $scope.switchEncryptionScreen = function(b) {
    $scope.bAdvanced_encryption_screen = !b;
   };
   $scope.onEncryptionDropdownClick = function(e) {
     $scope.proposedEncryptionType = e;
   };
   $scope.setRouterConfig = function(band,type,current_value,new_value,bssid/*,exitcode*/) {
    if(setRouterConfigValue) {
     var req = {band:ROUTERCONFIG.band_type[band],type:ROUTERCONFIG.config_type[type],current:current_value,new:new_value,bssid:bssid};
     setRouterConfigValue(req);
     req.config_type = type;
     ROUTERCONFIG.request= req;
    }
    else console.log("no callback");
   };
   $scope.showPage = function(page) {
    $scope[page] = true;
    $scope.hideMainPage = true;
    $timeout(function(){$scope.$apply()},0);
   };
   $scope.onBackBtnClick = function(page) {
    $scope[page] = false;
    $scope.hideMainPage = false;
    $timeout(function(){$scope.$apply()},0);
   };
   $scope.isDesktop = function() {
      var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      dt = false;
      if (macosPlatforms.indexOf(platform) !== -1) {
        dt = true;
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        dt = false;
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        dt = true;
      } else if (/Android/.test(userAgent)) {
        dt = false;
      } else if (/Linux/.test(platform)) {
        dt = true;
      }
      return dt;
    };
    $scope.bDesktop = $scope.isDesktop();

   var help_modal = document.getElementById('helpModal');
   $scope.showHelpInfo = function(type) {
    $scope.help_info = {};
    ROUTERCONFIG.help_info.forEach(function(x){
     if(type == x.type) {
      $scope.help_info = x;
      $timeout(function(){$scope.$apply()},0);
     }
     help_modal.style.display = "block";
    });
   };
   $scope.closeHelpModal = function() {
    help_modal.style.display = "none";
   };
  }
};

export default ROUTERCONFIG;
